import { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { Post } from "../../../../utils/request"
import { Show } from "../../../../actions/SnackbarActions"
import FormBody from "./FormBody";

const BannerPrincipalEdit = () => {
    const [popup, SetPopup] = useState(false);
    const [popupMessage, SetPopupMessage] = useState("");

    const [loading, SetLoading] = useState(false);

    const { banner_id } = useParams();

    const dispatch = useDispatch();
    const history = useHistory();

    const Submit = async (data) => {
        if (!data?.image) {//tirar falso dps de adicionar a opção da imagem
            SetPopup(true);
            SetPopupMessage("Insira uma imagem");
            return;
        }
        else if(!data?.title){
            SetPopup(true);
            SetPopupMessage("Insira um título!");
            return
        }

        let form = new FormData();
        form.append("id", banner_id);
        form.append("image", data.image);
        form.append("link", data.link);
        form.append("title", data.title);
        form.append("bgcolor", data?.bgcolor);

        SetLoading(true);
        let response = await Post("site-rt/bannerPrincipal-images/alter", form);
        SetLoading(false);

        dispatch(Show({
            show: true,
            message: response?.message,
            severity: response?.severity
        }));

        if (response?.status === true) history.push("/site-rt/bannerPrincipal-home");
    }

    return (
        <div className="card">
            <SweetAlert
                warning
                show={popup}
                title="Atenção!"
                confirmBtnText="Ok"
                onConfirm={() => SetPopup(false)}
            >
                {popupMessage}
            </SweetAlert>
            <div className="card-body">
                <h2 className="title">Editar banner principal</h2>
                <p style={{ marginBottom: 0}}>Aqui são editadas os banners principais que apareceram na tela inicial do RT</p>
                <span style={{ color: "#888" }}>Tamanhos recomendados: 2560x731, 1920x548, 1360x388, 1280x366</span>
                <p style={{ color: "#888" }}>Proporção do banner: 21/6</p>
                <br/>
                <FormBody
                    OnConfirm={data => Submit(data)}
                    loading={loading}
                />
            </div>
        </div>
    );
}

export default BannerPrincipalEdit;